import { api } from 'app/utils/api/helpers'

export const getAliases = (teamGUID) => {
  return api.get(`sm/teams/${teamGUID}/preferences/team-id-aliases`)
}
